<ng-content select="eui-app-sidebar"></ng-content>

<div class="eui-app-main">
    <ng-content select="eui-app-top-message"></ng-content>

    <ng-content select="eui-app-header"></ng-content>

    <ng-container *ngIf="!appToolbar && (asService.state$ | async).hasHeader && (asService.breakpoints$ | async).isMobile; else elseBlock">
        <eui-app-toolbar>
            <eui-toolbar></eui-toolbar>
        </eui-app-toolbar>
    </ng-container>

    <ng-template #elseBlock>
        <ng-content select="eui-app-toolbar"></ng-content>
    </ng-template>

    <div class="eui-app-main-content" role="main">
        <ng-container *ngIf="customPageWrapper">
            <ng-content select="eui-app-page-wrapper"></ng-content>
        </ng-container>
        <ng-container *ngIf="!customPageWrapper">
            <router-outlet></router-outlet>
        </ng-container>
    </div>

    <ng-content select="eui-app-footer"></ng-content>
</div>

<eui-growl [value]="asService.growlMessages" [sticky]="asService.isGrowlSticky" [life]="asService.growlLife"
    [position]="asService.growlPosition" (clicked)="asService.growlCallback()"></eui-growl>

<eui-block-document [isBlocked]="(asService.state$ | async).isBlockDocumentActive"></eui-block-document>

<eui-dimmer [isDimmerActive]="(asService.state$ | async).isDimmerActive"></eui-dimmer>
